import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgUpwardiOs({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.414L3.707 12.71a1 1 0 11-1.414-1.414l9-9.002a.997.997 0 011.414 0l9 9.002a1 1 0 11-1.414 1.414L12 4.414z"
        fill={color}
      />
    </svg>
  )
}

export default SvgUpwardiOs
